<script>
	import Menu from "./Menu.svelte";
	import TopBar from "./TopBar.svelte";
	import moment from "moment"
	import {error} from "./stores.js"

	export let name;
	let pw = ""
	let wrongCode = false
	let showPatientName = false;
	let displayMenu = false;

	let patientName = ""

	let hashOptions = {}

	let correctPW = function(){
		//let unix = Math.floor( / 1000);
		let s = moment.utc()
		let d = s.date()
		let m = s.month()+1
		let dd = m * 5 * d * 9;

		let alphabet = ["a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l",
		"a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l"];

		let f = alphabet[m]
		let ff = alphabet[m*2]
		if(dd % 2 === 0) dd = dd/2;
		console.log(ff + dd + f)
		if(ff === undefined) ff = "";
		return ff + dd + f
	}()

	function evaluate() {
		if (pw !== correctPW) {
			wrongCode = true
		} else {
			wrongCode = false
			showPatientName = true
		}
	}

	function evaluateField(e) {
		if (e.charCode === 13) {
			evaluate()
		}
	}


	function showMenu() {
		hashOptions.patientName = patientName
		window.location.hash = JSON.stringify(hashOptions)
		displayMenu = true
	}

	function showMenuField(e) {
		if (e.charCode === 13) {
			displayMenu()
		}
	}

	function parseHash() {
		let hh = window.location.hash
		if(hh === "" || hh === null || hh === undefined) {
			return {}
		}
		hh = decodeURI(hh)
		return JSON.parse(hh.substring(1, hh.length))
	}

	function resetToLogin() {
		video = "";
		patientName = "";
		pw = "";
		showPatientName = false;
		displayMenu = false;
		window.location.hash = "";
	}

	setInterval(() => {
		hashOptions = parseHash()
		if (hashOptions.patientName !== "" && hashOptions.patientName !== undefined && hashOptions.patientName !== null) {
			patientName = hashOptions.patientName
			displayMenu = true;
		}
		if (hashOptions.video !== "") {
			video = hashOptions.video
		}
	}, 500)

	let video = ""
	let oldVideo = ""

	$: {
		if (video !== "" && video !== null && video !== undefined) {
			hashOptions.video = video
		}
	}

	$: {
		if (hashOptions.video !== "" && hashOptions.video !== null && hashOptions.video !== undefined) {

			window.location.hash = JSON.stringify(hashOptions)
		}
	}


</script>

<svelte:head>
	<link rel="preconnect" href="https://fonts.gstatic.com">
	<link href="https://fonts.googleapis.com/css2?family=Lato:wght@100;300;400;700&display=swap" rel="stylesheet">
</svelte:head>

<main class="" style={displayMenu ? "height:100px" : "height:100%"}>

	{#if !displayMenu}
		<h1>Hands on Care</h1>
	{:else}
		{#if $error !== ""}
			<p>{$error}</p>
		{:else}
			<h1 style="font-size: 2rem">Hands on Care</h1>
		{/if}
	{/if}

	{#if !displayMenu}
		<h2>Maternity and Birthing Clinic</h2>
		<h3>ULTRASOUND 1.18.4</h3>
	{/if}
	<hr>
	{#if !displayMenu}
		{#if showPatientName}
			<input bind:value={patientName} on:keypress={showMenuField} placeholder="Patient Name" type="text">
			<button on:click={showMenu} style="margin-bottom: 1rem">Continue</button>
		{:else}
			<input style="margin: 1rem" bind:value={pw} on:keypress={evaluateField} placeholder="Access Code" type="text">
			<button on:click={evaluate} style="margin-bottom: 1rem">Login</button>
			{#if wrongCode}
				<p style="color:darkred">ERROR: Incorrect Code Detected. This failure has been logged.</p>
			{:else}
				<p style="color:transparent"></p>
			{/if}
		{/if}
	{/if}

	{#if displayMenu}
		<TopBar patientName={patientName}></TopBar>
	{/if}
</main>


{#if displayMenu}
	<div class="">
		<Menu bind:video={video} onReset={resetToLogin}></Menu>
	</div>
{/if}

<style>
	hr {
		width: 100%;
		border: 2px solid midnightblue;
	}

	h1, h2, h3 {
		color: royalblue;
		filter: drop-shadow(0px 0px 4px royalblue);
	}

	p {
		color: white
	}

	h1 {
		text-transform: uppercase;
		font-size: 4rem;
		font-weight: 600;
		margin-bottom: 0;
		margin-top: 0;
	}
	h2 {
		margin-top: 0;
		font-size: 2rem;
		font-weight: 600;
		margin-bottom: 0;
	}
	h3 {
		text-transform: uppercase;
		font-size: 1.5rem;
		font-weight: 600;
		color: lightgray;
		filter: drop-shadow(0px 0px 4px lightgray);
	}

	main {
		text-align: center;
		max-width: none;
		width:100%;
		margin: 0 auto;
		background: linear-gradient(180deg, rgba(39,32,149,1) 0%, rgba(36,32,142,0.25) 60%, rgba(32,32,134,0) 100%);
		border: 3px solid midnightblue;
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}
</style>
